import React from "react";
import classNames from "classnames";

import { ButtonProps } from "./Button.types";
import "./Button.scss";

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = "solid",
      theme = "primary",
      size = "medium",
      uppercase = false,
      children,
      className,
      ...props
    },
    ref
  ) => {
    const classes = classNames(
      "elemental-button",
      `btn-${variant}-${theme}`,
      `btn-${size}`,
      {
        "btn-uppercase": uppercase,
      },
      className
    );

    return (
      <button
        data-testid="button-component"
        className={classes}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);

export default Button;
